import { render, staticRenderFns } from "./WaterMarkSwitch.vue?vue&type=template&id=dc6827e6&scoped=true"
import script from "./WaterMarkSwitch.vue?vue&type=script&lang=js"
export * from "./WaterMarkSwitch.vue?vue&type=script&lang=js"
import style0 from "./WaterMarkSwitch.vue?vue&type=style&index=0&id=dc6827e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6827e6",
  null
  
)

export default component.exports